
define('text!modules/form/readonly_template.html',[],function () { return '  <h5 class="form-label">\r\n    <%- label %>\r\n  </h5>\r\n  <div class="form-field read-only">\r\n    <p><%-value%></p>\r\n    <div style="float: right" class="js-media-fact-connection"></div>\r\n  </div>\r\n';});

